import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {AuthService} from '../auth.service';
import {AppConstants} from '../shared/app.constants';

@Injectable()
export class SettingsService {

  constructor(private http: HttpClient, private auth: AuthService, private appConstants: AppConstants) {
  }

  getStoreTimings(storeId): Observable<any> {
    const url = environment.apiBase + `stores/${storeId}/timings`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.get(url, headers).map(res => res).catch(this.appConstants.errorHandler);
  }

  addNewTiming(body): Observable<any> {
    const url = environment.apiBase + `stores/${body.store}/timings`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url,body, headers).map(res => res).catch(this.appConstants.errorHandler);
  }

  updateStoreTimings(body): Observable<any> {
    const url = environment.apiBase + `stores/${body.storeId}/timings`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, {timings:body.timings}, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  getStoreDetails(storeId): Observable<any> {
    const url = environment.apiBase + `stores/${storeId}`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.get(url, headers).map(res => res).catch(this.appConstants.errorHandler);
  }

  updateStoreDetails(body): Observable<any> {
    const url = environment.apiBase + `stores/${body.id}`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, body.event, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/settings/settings.service.ts